<template>
  <a-modal width="55%" v-model:visible="openMap" title="位置选择" append-to-body>
    <template #footer>
      <a-button key="back" @click="cancel">取消</a-button>
      <a-button key="submit" type="primary" :loading="loading" @click="confirmSelect">保存</a-button>
    </template>
    <div id="all">
      <a-row :gutter="[24, 8]">
        <a-col :span="12" style="position: relative;">
          搜索地址
          <a-input
            type="text"
            id="suggestId"
            ref="searchInput"
            name="address_detail"
            placeholder="请输入地址，按回车定位"
            @pressEnter="searchAddress"
            @input="InputQuery"
            class="input_style"
          />
          <div
            v-if="searchList.length"
            style="width:307px;max-height:300px;overflow:auto;background:#fff;border:1px solid #ccc;position:absolute;top:55px;left:12px;z-index:999;"
          >
            <div
              v-for="(item,i) in searchList"
              :key="i"
              @click="selectPoi(item)"
              style="padding:8px 10px;border-bottom:1px solid #eee;cursor:pointer;"
            >
              <div>{{item.name}}</div>
              <div style="font-size:12px;color:#666;">{{item.address}}</div>
            </div>
          </div>
        </a-col>
        <a-col :span="12">
          当前位置
          <el-input
            type="text"
            placeholder="请输入地址"
            v-model="addressInfo.address"
            class="input_style"
            :readonly="true"
          >
            <template #addonBefore>
              <div>
                {{ addressInfo.province }}{{ addressInfo.city }}{{ addressInfo.district }}
              </div>
            </template>
          </el-input>
        </a-col>
      </a-row>
      <div id="allmap" style="margin-top: 20px; width: 100%; height: 400px;"></div>
    </div>
  </a-modal>
</template>

<script>
import { message } from 'ant-design-vue';

/* eslint-disable no-undef */
const TIANDITU_TK = "b146c640158ee7a6b9648cf40a7b5ad6";

export default {
  name: "TDMap",
  props: {
    defaultInfo: {
      type: Object,
      default() {
        return { lng: "", lat: "" };
      },
    },
  },
  data() {
    return {
      addressInfo: {
        province: "",
        city: "",
        district: "",
        address: "",
        longitude: "",
        latitude: "",
      },
      openMap: false,
      loading: false,
      center: { lng: 113.60528, lat: 37.87302 },
      map: null,
      marker: null,
      keyWord:'',
      searchList:[]
    };
  },

  methods: {
    initTianditu() {
      this.$nextTick(() => {
        this.map = new T.Map("allmap");
        let point;
        if (this.defaultInfo.lng) {
          point = new T.LngLat(this.defaultInfo.lng, this.defaultInfo.lat);
        } else {
          point = new T.LngLat(this.center.lng, this.center.lat);
        }

        this.map.centerAndZoom(point, 16);
        this.map.enableScrollWheelZoom();
        this.addMarker(point);
        this.geocAddress(point);

        this.map.addEventListener("click", (e) => {
          const pt = e.lnglat;
          this.addMarker(pt);
          this.geocAddress(pt);
        });
      });
    },
    InputQuery(e){
      this.keyWord=e.target.value
      this.search(e.target.value)
    },
    async search(value) {
      const kw = value

      // 构造postStr（v2/search标准参数）
      const postStr = JSON.stringify({
        keyWord: kw,
        queryType: 7, // 7=地名+POI混合（模糊）
        start: 0,
        count: 10,
        level: 12,
        mapBound: "73.66,3.86,135.08,53.55" // 全国搜索
      })

      const url = `https://api.tianditu.gov.cn/v2/search?postStr=${encodeURIComponent(postStr)}&type=query&tk=${TIANDITU_TK}`

      try {
        const res = await fetch(url).then(r => r.json())
        this.searchList = res?.pois || []
      } catch (e) {
        console.error('搜索失败', e)
        this.searchList = []
      }
    },
    
    addMarker(point) {
      if (this.marker) this.map.removeOverLay(this.marker);
      this.marker = new T.Marker(point);
      this.map.addOverLay(this.marker);
    },
    async selectPoi(item) {
      let data=await item
      // let lonlatList=data.lonlat.split(',')
      // let lonlatObj={
      //   lat:lonlatList[1],
      //   lng:lonlatList[0]
      // }
      this.$refs.searchInput.input.value = data.name
      this.searchAddress()
      // 清空下拉
      this.searchList = []
    },
    // 逆地址解析（坐标 → 地址）
    async geocAddress(point) {
      this.addressInfo.longitude = point.lng;
      this.addressInfo.latitude = point.lat;
      try {
        const url = `https://api.tianditu.gov.cn/geocoder?postStr=${encodeURIComponent(JSON.stringify({ lon: point.lng, lat: point.lat, ver: 1 }))}&type=geocode&tk=${TIANDITU_TK}`;

        const res = await fetch(url);
        const data = await res.json();
        if (!data.result) return;

        const ad = data.result.addressComponent || {};
        this.addressInfo.province = ad.province || "";
        this.addressInfo.city = ad.city || "";
        this.addressInfo.district = ad.county || "";
        this.addressInfo.address = data.result.formatted_address || "未知地址";
      } catch (e) {
        console.error("地址解析失败", e);
      }
    },


async searchAddress() {
  const inputEl = this.$refs.searchInput?.input;
  if (!inputEl) {
    return;
  }

  const address = inputEl.value.trim();
  console.log("搜索地址：", address);
  
  if (!address) {
    message.warning("请输入地址");
    return;
  }

  if (!this.map) {
    message.warning("地图未初始化");
    return;
  }

  try {
    // 使用天地图地理编码API（地址转坐标）
    const url = `https://api.tianditu.gov.cn/geocoder?ds={"keyWord":"${encodeURIComponent(address)}"}&tk=${TIANDITU_TK}&type=geo`;
    
    const res = await fetch(url);
    const data = await res.json();
    console.log("API返回结果：", data);
    
    if (data.status === "0" && data.location) {
      const { lon, lat } = data.location;
      const point = new T.LngLat(lon, lat);
      
      // 移动地图并缩放
      this.map.centerAndZoom(point, 16);
      // 添加标记
      this.addMarker(point);
      // 逆地理编码获取详细地址
      await this.geocAddress(point);
      
      message.success("定位成功！");
    } else {
      message.error("未找到该地址，请尝试输入更详细的位置信息");
    }
  } catch (e) {
    console.error("地址搜索失败", e);
  }
},

    show() {
      this.openMap = true;
      this.$nextTick(() => this.initTianditu());
    },

    confirmSelect() {
      this.$emit("confirmMapAddress", {
        ...this.addressInfo,
        lng: this.addressInfo.longitude,
        lat: this.addressInfo.latitude,
      });
      this.openMap = false;
    },

    cancel() {f
      this.openMap = false;
    },
  },
};
</script>

<style lang="less">
.tdt-suggest {
  z-index: 9999 !important;
}
.input_style {
  width: 100%;
}
</style>